import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Divider, Modal, Col, Row, Card } from 'antd';
import NewsService from 'services/promemoria/Promemoria';
import moment from 'moment';
import pdfIcon from 'assets/img/formats/pdf.png';
import xlsIcon from 'assets/img/formats/xls.png';
import csvIcon from 'assets/img/formats/csv.png';
import jsonIcon from 'assets/img/formats/json.png';
import CsvDownloader from 'react-csv-downloader';
import Utils from 'utils';
import { CloseOutlined } from '@ant-design/icons';

function News({ isMobile }) {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    return await NewsService.operations();
  };

  useEffect(() => {
    setLoading(true);
    fetchData().then(({ data }) => {
      setNews(
        data.body.sort((a, b) => new Date(b.dataInizioValidita) - new Date(a.dataInizioValidita))
      );
      setLoading(false);
    });
    return () => setNews([]);
  }, []);

  const News = (title, subtitle, date, content, key) => {
    return (
      <li>
        <a>
          <div
            tabIndex="0"
            onClick={() =>
              Modal.info({
                className: 'modalHome',
                icon: null,
                closable: false,
                content: (
                  <>
                    <Row className="TopModalDiv">
                      <Col span={23} className="TitlesModals">
                        <h1 className="titleModal h4">{title}</h1>
                      </Col>
                      <Col span={1} className="InfoModals">
                        <button
                          onClick={() => {
                            Modal.destroyAll();
                          }}>
                          <CloseOutlined className="p-2" />
                        </button>
                      </Col>
                    </Row>
                    <Row className="TopModalDiv">
                      <Col span={24} className="TitlesModals">
                        <small className="subtitleModal text-justify">{subtitle}</small>
                      </Col>
                    </Row>
                    <div className="contentModal">
                    <div>
                      <span style={{fontWeight:"600"}}>Data Pubblicazione: </span>{moment(date).format('DD/MM/YYYY')}</div>
                      {/* <p>{content}</p> */}
                    </div>
                  </>
                )
              })
            }
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                Modal.info({
                  className: 'modalHome',
                  icon: null,
                  closable: false,
                  content: (
                    <>
                      <Row className="TopModalDiv">
                        <Col span={23} className="TitlesModals">
                          <h1 className="titleModal h4">{title}</h1>
                        </Col>
                        <Col span={1} className="InfoModals">
                          <button
                            onClick={() => {
                              Modal.destroyAll();
                            }}>
                            <CloseOutlined className="p-2" />
                          </button>
                        </Col>
                      </Row>
                      <Row className="TopModalDiv">
                        <Col span={24} className="TitlesModals">
                          <small className="subtitleModal text-justify">{subtitle}</small>
                        </Col>
                      </Row>
                      <div className="contentModal">
                      <div>
                        <span style={{fontWeight:"600"}}>Data Pubblicazione: </span>{moment(date).format('DD/MM/YYYY')}</div>
                        {/* <p>{content}</p> */}
                      </div>
                    </>
                  )
                });
              }
            }}
            className="news-body"
            key={key}>
            {/* <div className="d-flex justify-content-between"> */}
            <div className="news-content">
              <div className="title" role="heading" aria-level="3">{title}</div>
            </div>
            <div>
              <div className="subtitle">{subtitle}</div>
            </div>
            <div className="news-date">
              <div className="date">
                <span style={{fontWeight:"600"}}>{t('home.news.date')}: </span><span className="date-detail">{moment(date).format('DD/MM/YYYY')}</span>
              </div>
            </div>
          </div>
        </a>
      </li>
    );
  };
  return (
    <div className="news-container">
      <h2 className="news-title mb-3">{t('home.news.title')}</h2>
      <Divider className="divisore-blu mt-0" />
      {!loading && (
        <div className="download-news-btns d-flex ">
          <button
            disabled={loading}
            onClick={() =>
              Utils.exportPDF(
                'Aggiornamenti -' + ' Data stampa ' + moment().format('DD/MM/YYYY HH:mm:ss'),
                [
                  { title: 'Titolo' },
                  { title: 'Data' },
                  { title: 'Descrizione' },
                  { title: 'Testo del provvedimento' },
                  { title: 'Note' }
                ],
                news.map((obj) => [
                  obj.titolo,
                  moment(obj.dataInizioValidita).format('DD/MM/YYYY'),
                  obj.testo,
                  obj.testoProvvedimento,
                  obj.sottotitolo
                ]),
                'portrait'
              )
            }>
            <img src={pdfIcon} alt="Scarica ultime news in formato PDF" />
          </button>
          <button
            className="ml-2"
            disabled={loading}
            onClick={() =>
              Utils.exportXLSX(
                'Aggiornamenti -' + ' Data stampa ' + moment().format('DD/MM/YYYY HH:mm:ss'),
                ['Titolo', 'Data', 'Descrizione', 'Testo del provvedimento', 'Note'],
                news.map((obj) => [
                  obj.titolo,
                  moment(obj.dataInizioValidita).format('DD/MM/YYYY'),
                  obj.testo,
                  obj.testoProvvedimento,
                  obj.sottotitolo
                ])
              )
            }>
            <img src={xlsIcon} alt="Scarica ultime news in formato XSLX" />
          </button>

          <CsvDownloader
            disabled={loading}
            className="ml-2"
            filename={'Aggiornamenti -' + ' Data stampa ' + moment().format('DD/MM/YYYY HH:mm:ss')}
            columns={[
              {
                id: 'cell1',
                displayName: 'Titolo'
              },
              {
                id: 'cell2',
                displayName: 'Data'
              },
              {
                id: 'cell3',
                displayName: 'Descrizione'
              },
              {
                id: 'cell4',
                displayName: 'Testo del provvedimento'
              },
              {
                id: 'cell5',
                displayName: 'Note'
              }
            ]}
            datas={news.map(
              ({ titolo, dataInizioValidita, sottotitolo, testoProvvedimento, testo }) => ({
                cell1: titolo,
                cell2: dataInizioValidita,
                cell3: testo,
                cell4: testoProvvedimento,
                cell5: sottotitolo
              })
            )}>
            <img src={csvIcon} alt="Scarica ultime news in formato CSV" />
          </CsvDownloader>
          <button
            className="ml-2"
            disabled={loading}
            onClick={() => {
              const fileData = JSON.stringify(
                news.map((obj) => {
                  return {
                    titolo: obj.titolo,
                    data: moment(obj.dataInizioValidita).format('DD/MM/YYYY'),
                    descrizione: obj.testo,
                    testoProvvedimento: obj.testoProvvedimento,
                    testo: obj.sottotitolo
                  };
                })
              );
              const blob = new Blob([fileData], { type: 'text/plain' });
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.download =
                'Aggiornamenti -' +
                ' Data stampa ' +
                moment().format('DD/MM/YYYY HH:mm:ss') +
                '.json';
              link.href = url;
              link.click();
            }}>
            <img src={jsonIcon} alt="Scarica ultime news in formato JSON" />
          </button>
        </div>
      )}
      <div className="novita-carta mt-md-0 mt-3">
        <ul style={{ paddingLeft: '0' }}>
          {news.map(
            ({
              titolo,
              testo,
              dataInizioValidita,
              idPromemoria,
              sottotitolo,
              testoProvvedimento,
              idProvvedimento
            }) =>
              News(
                titolo,
                testo,
                dataInizioValidita,
                sottotitolo,
                "news-" + idPromemoria,
                testoProvvedimento,
                idProvvedimento
              )
          )}
        </ul>
        {news && news.length > 0 &&
        <Link
          to={'/home/aggiornamenti'}
          className="seeAllStyle d-flex justify-content-end"
          aria-label={`Vedi tutti`}
          tabIndex={0}>
          Vedi tutti
        </Link>
        }
        {/* <Divider className="blue-divider" /> */}
      </div>
    </div>
  );
}

export default News;
